const FETCH_REPORT = 'adebify-custom-report/FETCH_REPORT';
const FETCH_REPORT_SUCCEEDED = 'adebify-custom-report/FETCH_REPORT_SUCCEEDED';
const REQUEST_START = 'adebify-custom-report/REQUEST_START';
const REQUEST_FAILED = 'adebify-custom-report/REQUEST_FAILED';

const SET_MODE = 'adebify-custom-report/SET_MODE';
const SET_ROW_DIMENSIONS = 'adebify-custom-report/SET_ROW_DIMENSIONS';
const SET_COLUMN_DIMENSIONS = 'adebify-custom-report/SET_COLUMN_DIMENSIONS';
const SET_METRICS = 'adebify-custom-report/SET_METRICS';
const SET_AXIS = 'adebify-custom-report/SET_AXIS';
const SET_PRODUCT_AXIS = 'adebify-custom-report/SET_PRODUCT_AXIS';
const SET_FILTERS = 'adebify-custom-report/SET_FILTERS';
const SET_TOUCH_POINT_TARGETS = 'adebify-custom-report/SET_TOUCH_POINT_TARGETS';

const UPDATE_PAGE = 'adebify-custom-report/UPDATE_PAGE';
const UPDATE_SORT = 'adebify-custom-report/UPDATE_SORT';

const SET_CV_DISPLAY_COLUMNS = 'adebify-custom-report/SET_CV_DISPLAY_COLUMNS';

const RESET_SETTINGS = 'adebify-custom-report/RESET_SETTINGS';
const HYDRATE_SETTINGS = 'adebify-custom-report/HYDRATE_SETTINGS';
const DOWNLOAD_CSV = 'adebify-custom-report/DOWNLOAD_CSV';

export default {
  FETCH_REPORT,
  FETCH_REPORT_SUCCEEDED,
  REQUEST_START,
  REQUEST_FAILED,

  SET_MODE,
  SET_ROW_DIMENSIONS,
  SET_COLUMN_DIMENSIONS,
  SET_METRICS,
  SET_AXIS,
  SET_PRODUCT_AXIS,
  SET_FILTERS,
  SET_TOUCH_POINT_TARGETS,

  UPDATE_PAGE,
  UPDATE_SORT,

  SET_CV_DISPLAY_COLUMNS,
  RESET_SETTINGS,
  HYDRATE_SETTINGS,
  DOWNLOAD_CSV,
};
